import { t } from "i18next"
import { React, useEffect, useState } from "react"

import nextIcon from "../../../assets/common/next_pagination.svg"
import previousIcon from "../../../assets/common/previous_pagination.svg"
import { pageOptions } from "../../../utils/Constant"
import Dropdown from "../Form/DropdownWithSetValueSupport"
import { usePaginationPages } from "./usePaginationPages"

const Pagination = ({ gotoPage, length, pageSize, setPageSize, pageindex, onPaginationClicked, paginationShow }) => {
    const [perPage, setPerPage] = useState(pageSize)
    const [visiblePages, setVisiblePages] = useState([])
    const {
        canGo,
        currentPage,
        totalPages,
        totolRecords,
        goTo
    } = usePaginationPages({
        gotoPage,
        length,
        pageSize,
        pageindex
    })

    useEffect(() => {
        setPageSize(Number(perPage))
    }, [perPage, setPageSize])

    useEffect(() => {
        setPageSize(Number(perPage))
    }, [ pageindex ])

    const pagestoshow = 6

    const getVisiblePages = (page, total) => {
        if (total < pagestoshow) {
            return filterPages([1, 2, 3, 4, 5], total)
        } else {
            if (page % 4 >= 0 && page > 3 && page + 1 < total) {
                return [1, page - 1, page, page + 1, total]
            } else if (page % 4 >= 0 && page > 3 && page + 1 >= total) {
                return [1, total - 3, total - 2, total - 1, total]
            } else {
                return [1, 2, 3, 4, total]
            }
        }
    }

    const filterPages = (visiblePages, totalPages) => {
        return visiblePages.filter((page) => page <= totalPages)
    }

    useEffect(() => {
        const visiblePages = getVisiblePages(currentPage, totalPages)
        setVisiblePages(visiblePages)
    }, [totalPages])

    const changePage = (page) => {
        onPaginationClicked && onPaginationClicked(page)    
        const visiblePages = getVisiblePages(page, totalPages)
        const filteredPages = filterPages(visiblePages, totalPages)
        setVisiblePages(filteredPages)      
        goTo(page)   
    }

    const getCurrentRecordCount = () => {
        const currentIndex = currentPage
        const currentpageSize = pageSize
        if (currentIndex == 1) {
            return `1 - ${currentpageSize}`
        }
        const startRecord = (currentIndex * currentpageSize + 1) - currentpageSize
        const endRecord = (currentIndex * currentpageSize) <= length ? 
            (currentIndex * currentpageSize) : length 
        return `${startRecord} - ${endRecord}`
    }

    const dropdownFilter = (dropdownValues) => {
        // Extract only the value properties for comparison
        let values = dropdownValues.map(item => item.value)    
        // Find the next higher value
        let nextHigher = values.find(value => value >= totolRecords)    
        // Filter values up to the next higher threshold
        let filteredValues = dropdownValues.filter(item => item.value <= totolRecords || item.value === nextHigher)     
        return filteredValues
    }


    return (
        totolRecords > 10 &&  <div className="flex flex-col justify-center items-center gap-[10px] slef-stretch">
            <div className="flex justify-center items-center gap-[12px]">
                <div className="flex items-center gap-[8px]">
                    <span className="text-xs font-lighter text-secondary-200">
                        { t("common.paginationResultText") }
                    </span>
                    <div className="flex w-[98px] flex-col items-start">
                        <Dropdown
                            placeholder=""
                            options= { dropdownFilter(pageOptions) }
                            name="pageSize"
                            value={ pageSize }
                            changeHandler={ e => {
                                setPerPage(e.value)
                            } }
                            isNotRequired={ true }
                            menuPlacement="top"
                            className="w-full p-0 m-0 pagination-dropdown"
                        />
                    </div>
                    <span className="text-xs font-lighter text-secondary-200">
                        { `${getCurrentRecordCount()} ${
                            t("common.paginationBetweenLabel")} ${totolRecords}` }
                    </span>
                </div>
                {  totolRecords > pageSize && pageSize &&  <div className="flex items-center gap-[12px]">
                    <button
                        type="button"
                        id={ "page_button_previous" }
                        className={ "text-primary-100 h-99 w-102 fill-current rounded-full hover:border-0" +
                        " hover:bg-primary-150 items-center flex justify-center m-0.5 p-4"
                        }
                        disabled={ !canGo.previous }
                        onClick={ () => {
                            changePage(currentPage - 1)
                        } }
                    >
                        <img
                            alt="previous"
                            src={ previousIcon }
                            className="max-w-none"
                            height={ "16px" }
                            width={ "16px" }
                        />
                    </button>
                    { visiblePages?.map((page, index, array) => {
                        if (array[index - 1] + 1 < page) {
                            return (
                                <>
                                    <button
                                        type="button"
                                        id={ "page_button_" + (array[index - 1] + 1).toString() }
                                        className={
                                            " h-99 w-102 fill-current rounded-full hover:border-0 items-center flex" +
                                        " justify-center m-0.5 p-4 text-primary-100"
                                        }
                                        onClick={ () => {
                                            changePage(array[index - 1] + 1)
                                        } }
                                    >
                                        ...
                                    </button>
                                    <button
                                        type="button"
                                        id={ "page_button_" + page.toString() }
                                        className={
                                            " h-99 w-102 fill-current text-primary-100" +
                                            " items-center flex justify-center m-0.5 p-4" +
                                            (page === currentPage
                                                ? " border-b-2 border-primary-100"
                                                : "  border-b-2 border-transparent hover:border-primary-100")
                                        }
                                        onClick={
                                            page !== currentPage
                                                ? () => {
                                                    changePage(page)
                                                }
                                                : () => { }
                                        }
                                    >
                                        { page }
                                    </button>
                                </>
                            )
                        } else {
                            return (
                                <button
                                    key={ index }
                                    type="button"
                                    id={ "page_button_" + page.toString() }
                                    className={
                                        " h-99 w-102 fill-current " +
                                        " items-center flex justify-center m-0.5 p-4 text-primary-100 " +
                                        (page === currentPage
                                            ? " border-b-2 border-primary-100"
                                            : "  border-b-2 border-transparent hover:border-primary-100")
                                    }
                                    onClick={
                                        page !== currentPage
                                            ? () => {
                                                changePage(page)
                                            }
                                            : () => { }
                                    }
                                >
                                    { page }
                                </button>
                            )
                        }
                    }) }
                    <button
                        type="button"
                        id={ "page_button_previous" }
                        className={ "text-primary-100 h-99 w-102 fill-current rounded-full hover:border-0" +
                        " hover:bg-primary-150 items-center flex justify-center m-0.5 p-4"
                        }
                        disabled={ !canGo.next }
                        onClick={ () => {
                            changePage(currentPage + 1)
                        } }
                    >
                        <img alt="next" src={ nextIcon } className="max-w-none" height={ "16px" } width={ "16px" } />
                    </button>        
                </div> }
            </div>

        </div>
    )
}

export default Pagination
